'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchBidderDataIfNeeded = exports.logOutBidder = exports.getMainhostLogin = exports.isProfileComplete = exports.isBidderLoaded = exports.getBidderId = exports.getUserData = exports.isUserAtLeastPartiallyRegistered = exports.isUserLoggedIn = exports.isUserPartiallyRegistered = exports.isConfirmPasswordTriggered = exports.getBidderType = exports.getBidderEmail = exports.getAuthToken = exports.LOG_OUT_BIDDER = exports.LOAD_BIDDER_DATA_SUCCESS = exports.LOAD_BIDDER_DATA_REQUEST = exports.LOAD_BIDDER_DATA_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _completeAccount = require('../modules/completeAccount');

var _createAccount = require('../modules/createAccount');

var _login = require('../modules/login');

var _updateAccount = require('../modules/updateAccount');

var _api = require('../api');

var _confirmPassword = require('../modules/confirmPassword');

var _reselect = require('reselect');

var _config = require('../modules/config');

var _jwtDecode = require('jwt-decode');

var _jwtDecode2 = _interopRequireDefault(_jwtDecode);

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _shouldLogin = require('../modules/shouldLogin');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_BIDDER_DATA_FAIL = exports.LOAD_BIDDER_DATA_FAIL = 'la/domain/bidderData/LOAD_FAIL';
var LOAD_BIDDER_DATA_REQUEST = exports.LOAD_BIDDER_DATA_REQUEST = 'la/domain/bidderData/LOAD_REQUEST';
var LOAD_BIDDER_DATA_SUCCESS = exports.LOAD_BIDDER_DATA_SUCCESS = 'la/domain/bidderData/LOAD_SUCCESS';
var LOG_OUT_BIDDER = exports.LOG_OUT_BIDDER = 'LOG_OUT_BIDDER';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');
var UNREGISTERED = 'unregistered';
var PARTIALLYREGISTEREDBIDDER = 'PartiallyRegisteredBidder';
var REGISTEREDBIDDER = 'bidder';

/* reducer */
var DEFAULT_STATE = {
    authName: '',
    authNuid: '',
    authVerify: '',
    confirmPasswordRequiredTriggered: false,
    loaded: 0,
    loading: false,
    mobile: '',
    token: '',
    userData: {}
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var time = void 0;

    switch (action.type) {
        case _createAccount.CREATE_ACCOUNT_SUCCESS:
            time = action.meta.actionTime;
            return (0, _extends3.default)({}, state, {
                loaded: time,
                loading: false,
                token: action.payload
            });
        case _login.LOGIN_SUCCESS:
        case _confirmPassword.CONFIRM_PASSWORD_SUCCESS:
        case _completeAccount.COMPLETE_ACCOUNT_SUCCESS:
            time = action.meta.actionTime;
            if (typeof action.payload.annualNMS !== 'undefined') {
                action.payload.bidder.ANMS = action.payload.annualNMS;
            }
            return (0, _extends3.default)({}, state, {
                authName: action.payload.mainhostLogin['5Xq_name'],
                authNuid: action.payload.mainhostLogin['5Xq_nuid'],
                authVerify: action.payload.mainhostLogin['5Xq_nverify'],
                confirmPasswordRequiredTriggered: false,
                loaded: time,
                loading: false,
                token: action.payload.token,
                userData: (0, _extends3.default)({}, action.payload.bidder, {
                    bidderId: Number(action.payload.bidder.bidderId)
                })
            });
        case LOAD_BIDDER_DATA_REQUEST:
        case _login.LOGIN_REQUEST:
        case _createAccount.CREATE_ACCOUNT_REQUEST:
        case _completeAccount.COMPLETE_ACCOUNT_REQUEST:
        case _updateAccount.UPDATE_ACCOUNT_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case LOAD_BIDDER_DATA_SUCCESS:
        case _updateAccount.UPDATE_ACCOUNT_SUCCESS:
            time = action.meta.actionTime;
            if (typeof action.payload.annualNMS !== 'undefined') {
                action.payload.bidder.ANMS = action.payload.annualNMS;
            }
            return (0, _extends3.default)({}, state, {
                loaded: time,
                loading: false,
                userData: (0, _extends3.default)({}, action.payload.bidder, {
                    bidderId: Number(action.payload.bidder.bidderId)
                })
            });
        case _shouldLogin.OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                confirmPasswordRequiredTriggered: true
            });
        case LOG_OUT_BIDDER:
            return (0, _extends3.default)({}, state, {
                authName: '',
                authNuid: '',
                authVerify: '',
                confirmPasswordRequiredTriggered: false,
                loaded: 0,
                loading: false,
                token: '',
                userData: {}
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.user.user;
};

var userDataSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.userData;
});

var getAuthToken = exports.getAuthToken = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.token ? state.token : null;
});

var getBidderEmail = exports.getBidderEmail = (0, _reselect.createSelector)(userDataSelector, function (userData) {
    return userData != null ? userData.email : '';
});

var getBidderType = exports.getBidderType = (0, _reselect.createSelector)(getAuthToken, function (token) {
    if (token) {
        try {
            // TODO: see if this try catch is enough.  We shouldn't throw if something is wrong
            return (0, _jwtDecode2.default)(token).type;
        } catch (error) {
            return UNREGISTERED;
        }
    }
    return UNREGISTERED;
});

var isConfirmPasswordTriggered = exports.isConfirmPasswordTriggered = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.confirmPasswordRequiredTriggered;
});

var isUserPartiallyRegistered = exports.isUserPartiallyRegistered = (0, _reselect.createSelector)(getBidderType, function (bidderType) {
    return bidderType === PARTIALLYREGISTEREDBIDDER;
});

var isUserRegistered = (0, _reselect.createSelector)(getBidderType, function (bidderType) {
    return bidderType === REGISTEREDBIDDER;
});

var isUserLoggedIn = exports.isUserLoggedIn = (0, _reselect.createSelector)(getAuthToken, isUserRegistered, function (token, registered) {
    return !!token && registered;
});

var isUserAtLeastPartiallyRegistered = exports.isUserAtLeastPartiallyRegistered = (0, _reselect.createSelector)(isUserPartiallyRegistered, isUserLoggedIn, function (registered, loggedIn) {
    return registered || loggedIn;
});

var getUserData = exports.getUserData = (0, _reselect.createSelector)(isUserAtLeastPartiallyRegistered, userDataSelector, function (userAtLeastPartiallyRegistered, userData) {
    return userAtLeastPartiallyRegistered ? userData : null;
});

var getBidderId = exports.getBidderId = (0, _reselect.createSelector)(userDataSelector, function (userData) {
    return userData != null ? userData.bidderId : 0;
});

var isBidderLoaded = exports.isBidderLoaded = (0, _reselect.createSelector)(getBidderId, function (bidderId) {
    return bidderId > 0;
});

var isProfileComplete = exports.isProfileComplete = (0, _reselect.createSelector)(userDataSelector, function (userData) {
    return userData ? !!userData.profileComplete : false;
});

var getLoadTimeForUserData = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded || 0;
});

var isUserDataLoading = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading || false;
});

var shouldFetchUserData = function shouldFetchUserData(state) {
    var userAtLeastPartiallyRegistered = isUserAtLeastPartiallyRegistered(state);
    if (!userAtLeastPartiallyRegistered) return false;

    var userData = getUserData(state);
    if (userData) {
        var loaded = getLoadTimeForUserData(state);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isUserDataLoading(state);
    return !loading;
};

var getMainhostLogin = exports.getMainhostLogin = (0, _reselect.createSelector)(stateSelector, function (state) {
    return {
        authName: state.authName,
        authNuid: state.authNuid,
        authVerify: state.authVerify
    };
});

/* ACTION CREATORS */
var logOutBidder = exports.logOutBidder = function logOutBidder() {
    return {
        type: LOG_OUT_BIDDER
    };
};

var loadBidderData = function loadBidderData(_ref) {
    var authToken = _ref.authToken,
        deployment = _ref.deployment;
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch) {
            var response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;

                            dispatch({
                                payload: authToken,
                                type: LOAD_BIDDER_DATA_REQUEST
                            });
                            _context.next = 4;
                            return _api.Bidder.fetchBidderData({ authToken: authToken, deployment: deployment });

                        case 4:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: LOAD_BIDDER_DATA_SUCCESS
                            });
                            _context.next = 12;
                            break;

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { token: authToken },
                                payload: _context.t0,
                                type: LOAD_BIDDER_DATA_FAIL
                            });
                            dispatch(logOutBidder());

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 8]]);
        }));

        return function (_x3) {
            return _ref2.apply(this, arguments);
        };
    }();
};

var fetchBidderDataIfNeeded = exports.fetchBidderDataIfNeeded = function fetchBidderDataIfNeeded(token, force) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = token || getAuthToken(state);
        var deployment = (0, _config.getDeployment)(state);
        if (force || shouldFetchUserData(state)) {
            return dispatch(loadBidderData({ authToken: authToken, deployment: deployment }));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/user.js
// module id = CFLi
// module chunks = 46